/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_contact_discord_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hang out with the community, talk F1 Fantasy, share ideas, and get help. There are dedicated channels for tool ideas, bug reports, and F1 Fantasy.`)
};

const es_contact_discord_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasa el rato con la comunidad, habla de F1 Fantasy, comparte ideas y obtén ayuda. Hay canales dedicados para ideas de herramientas, informes de errores y F1 Fantasy.`)
};

const de_contact_discord_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Triff die Community, sprich über F1 Fantasy, teile Ideen und hol dir Hilfe. Es gibt eigene Kanäle für Tool-Ideen, Fehlerberichte und F1 Fantasy.`)
};

const nl_contact_discord_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom samen met de community, praat over F1 Fantasy, deel ideeën en krijg hulp. Er zijn aparte kanalen voor tool-ideeën, bugmeldingen en F1 Fantasy.`)
};

const fr_contact_discord_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échangez avec la communauté, parlez de F1 Fantasy, partagez vos idées et obtenez de l'aide. Des salons dédiés existent pour les idées d'outils, les rapports de bugs et F1 Fantasy.`)
};

const it_contact_discord_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passa del tempo con la community, parla di F1 Fantasy, condividi idee e ricevi aiuto. Ci sono canali dedicati per idee sugli strumenti, segnalazioni di bug e F1 Fantasy.`)
};

const pt_br2_contact_discord_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converse com a comunidade, fale sobre F1 Fantasy, compartilhe ideias e tire dúvidas. Há canais dedicados para ideias de ferramentas, relatos de bugs e F1 Fantasy.`)
};

const pt_contact_discord_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convive com a comunidade, fala sobre F1 Fantasy, partilha ideias e obtém ajuda. Há canais dedicados para ideias de ferramentas, relatórios de erros e F1 Fantasy.`)
};

const ja_contact_discord_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コミュニティと交流し、F1 Fantasy について語り、アイデアを共有して、サポートを受けましょう。ツールのアイデア、バグ報告、F1 Fantasy 専用のチャンネルがあります。`)
};

const zh_contact_discord_body = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`和社区一起交流，畅聊 F1 Fantasy，分享创意并获得帮助。我们有专门的频道用于工具创意、bug 反馈和 F1 Fantasy。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_discord_body = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_discord_body(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("contact_discord_body", locale)
	if (locale === "en") return en_contact_discord_body(inputs)
	if (locale === "es") return es_contact_discord_body(inputs)
	if (locale === "de") return de_contact_discord_body(inputs)
	if (locale === "nl") return nl_contact_discord_body(inputs)
	if (locale === "fr") return fr_contact_discord_body(inputs)
	if (locale === "it") return it_contact_discord_body(inputs)
	if (locale === "pt-BR") return pt_br2_contact_discord_body(inputs)
	if (locale === "pt") return pt_contact_discord_body(inputs)
	if (locale === "ja") return ja_contact_discord_body(inputs)
	return zh_contact_discord_body(inputs)
};